module.exports = __webpack_public_path__ + "static/img/ic_review@2x.b020dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/ic_review@2x.png
// module id = egWZ
// module chunks = 10